import mutations from './mutations';
import actions from './actions';
import getters from './getters';

export default {
    state() {
        return {
            dashboardChartData: [],
            dashboardAssets: 0.0,
            dashboardLiabilities: 0.0,
            dashboardSelfManaged: 0.0,
            dashboardClarityAssets: 0.0,
            dashboardBankAccounts: 0.0,
            isSubscribed: null,
        };
    },
    mutations,
    actions,
    getters,
};
